<template>
  <div>
    <router-view />
    <apollo-posts class="grow overflow-hidden" v-show='showMainFeed' :type='feedType' feed-type="flat">
    </apollo-posts>
  </div>

</template>


<script>
import ApolloPosts from '@ui/organisms/ApolloPosts.vue';

export default {
  props: {
    feed:{
      type:String,
      default:'hot'
    }
    
  },
  data() {
    return {
    }
  },
  components:{
    ApolloPosts,
  },
  mounted() {
  },
  methods:{
  },
  beforeRouteEnter(to, from, next) {
    if (false && from.name === 'create' && to.query.posted) {
      const postId = to.query.postedId;
      next( (vm) => {
        if (vm.downloadTimer) {
          clearTimeout(vm.downloadTimer);
        }
        vm.downloadTimer = setTimeout( () => {
          console.log('PUSH DOWNLOAD CLIP!!!!!!!!!!!');
          vm.$router.push({
            name:'downloadClipNew',
            params:{
              postId
            }
          });
          delete vm.downloadTimer;
        }, 0);
      });
    } else {
      next();
    }
  },
  computed:{
    showMainFeed() {
      return this.$route.name !== 'play' && this.$route.name !== 'playnew';
    },
    defaultType() {
      return this.feed || 'hot';
    },
    feedType() {
      const anyRouteIsNew = this.$route.matched.filter( ({name}) => {
        return name === 'new';
      }).length > 0;
      const anyRouteIsHot = this.$route.matched.filter( ({name}) => {
        return name === 'hot';
      }).length > 0;

      if (anyRouteIsNew) {
        return 'new';
      } else if (anyRouteIsHot) {
        return 'hot'
      }
      return 'hot';

    }
  }
}
</script>
<style>
</style>
